import angular from 'angular';

import routeProviderConfig from './configs/routeProvider.config';

import upload from './components/upload/upload.component';

/**
 * @ngdoc overview
 * @name upload
 * @description
 * This module handles everything for the Upload section.
 */
const uploadModule = angular.module('upload', [])
.config(routeProviderConfig)
.component('upload', upload);

export default uploadModule.name;



// WEBPACK FOOTER //
// ./src/frontend/modules/upload/index.js